<template>
    <div>
        <div class="addmember1">
            <span class="mbtb1" :class="{'jsActive':jsType==1}" @click="setJsType(1)">快捷结算</span>
            <span class="mbtb1" :class="{'jsActive':jsType==2}" @click="setJsType(2)">混合结算</span>
            <i class="el-icon-close mbbt-icon" @click="fanhui"></i>
        </div>
        <div style="padding-bottom: 40px">
            <div class="jisuanje">
                <div v-if="member&&member.id">
                    <span style="margin-right: 18px">客户</span>
                    <span style="margin-right: 3px">{{member.memberName}}</span>
                    <span style="font-size: 10px">{{member.phone}}</span>
                </div>
                <div v-else>
                    散客
                </div>
            </div>
            <div class="jisuanje">
                <span>结算金额</span>
                <div style="color: red">
                    <span style="font-size: 10px">¥</span>
                    <span style="font-size: 20px">{{totalAmount}}</span>
                </div>
            </div>
            <div class="jisuanje">
                <div class="mb-sex">
                    <el-radio-group v-model="radio" style="margin-top: 7px;">
                        <el-radio :label="1">开单</el-radio>
                        <el-radio :label="2" style="margin-left: -10px" v-if="bdqx">补单</el-radio>
                    </el-radio-group>
                </div>
                <div class="srdate2" v-if="radio==2" @click="toShiJian()">{{kdDate}}</div>
            </div>
            <div class="jisuanfs" v-if="jsType==1">
                <span>结算方式</span>
                <van-radio-group v-model="payType" style="margin-top: 10px">
                    <van-radio :name="item.value" checked-color="#07c160" class="radio-btn"
                               v-for="item in payTypes"><span style="width: 68px;display: inline-block">{{item.name}}</span>
                        <span v-if="item.value==0||item.value==1" style="margin-left: 5px;color: #919191">{{item.amount}}</span>
                    </van-radio>
                </van-radio-group>
            </div>
            <div class="hunhepay" v-if="jsType==2">
                <div class="hhitem">
                    <div class="paykuang-item">
                        <span>现 金</span>
                        <el-input v-model="hh.cash" size="small" placeholder="请输入号码" class="ki"></el-input>
                    </div>
                    <div class="paykuang-item">
                        <span>微 信</span>
                        <el-input v-model="hh.wx" size="small" placeholder="请输入号码" class="ki"></el-input>
                    </div>
                    <div class="paykuang-item">
                        <span>支付宝</span>
                        <el-input v-model="hh.ali" size="small" placeholder="请输入号码" class="ki"></el-input>
                    </div>
                    <div class="paykuang-item">
                        <span>美团</span>
                        <el-input v-model="hh.mt" size="small" placeholder="请输入号码" class="ki"></el-input>
                    </div>
                    <div class="paykuang-item">
                        <span>抖音</span>
                        <el-input v-model="hh.dy" size="small" placeholder="请输入号码" class="ki"></el-input>
                    </div>
                    <div class="paykuang-item">
                        <span>卡金</span>
                        <el-input v-model="hh.card" size="small" placeholder="请输入号码" class="ki"></el-input>
                    </div>
                    <div class="paykuang-item">
                        <span>赠送金</span>
                        <el-input v-model="hh.give" size="small" placeholder="请输入号码" class="ki"></el-input>
                    </div>
<!--                    <div class="paykuang-item">-->
<!--                        <span>欠款</span>-->
<!--                        <el-input v-model="hh.wx" size="small" placeholder="请输入号码" class="ki"></el-input>-->
<!--                    </div>-->
                </div>
            </div>
        </div>
        <div class="jiesuan-btn">
            <van-button type="default" :loading="isDisabled" class="jiesuanbtn" @click="jiesuan()">结算</van-button>
        </div>
        <van-popup v-model="sjShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false">
            <van-datetime-picker
                    v-model="mrDate"
                    type="date"
                    :min-date="minDate"
                    @confirm="queding"
                    @cancel="quxiao"
            />
        </van-popup>
    </div>
</template>

<script>

    import {formatDate, getCookie} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                deptId:'',
                token:'',
                sjShow: false,
                totalAmount: '0',
                radio: 1,
                kdDate: '请选择日期',
                minDate: new Date("1900-01-01"),
                mrDate: new Date(),

                isDisabled: false,
                payType: '2',
                payTypes: [
                    {'name': '现金', 'value': '2','ye': 0},
                    {'name': '美团', 'value': '5','ye': 0},
                    {'name': '抖音', 'value': '6','ye': 0},
                ],
                member:{},
                vmemberId:'',
                cardId:'',
                url:'',
                data:{},
                orderType:'',

                jsType:1,

                hh: {
                    cash: 0,
                    wx: 0,
                    ali: 0,
                    mt: 0,
                    dy: 0,
                    card: 0,
                    give: 0,
                    arrears: 0,
                    sj: 0,
                },
                qxs:['bdqx'],
                bdqx:false,
            };
        },
        props:{
            payItem:Object,
        },
        async created() {
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getPermissionList()
            this.chushi()
            this.getPayTypes()
        },
        methods: {
            async getPermissionList() {
                let data = {
                    token: this.token,
                    qxs:JSON.stringify(this.qxs)
                }
                let res = await this.$post("/fw/getPermissionList", data)
                if (res.permissionList.length > 0) {
                    this.permissionList = res.permissionList
                    if (this.permissionList.indexOf('bdqx') > -1) {
                        this.bdqx = true
                    }
                }
            },
            chushi(){
                if (this.payItem.memberId){
                    this.memberId=this.payItem.memberId
                    this.getMemberInfo()
                }
                if (this.payItem.cardId){
                    this.cardId=this.payItem.cardId
                }
                this.data=this.payItem.data
                this.totalAmount=this.payItem.totalStr

            },
            async getMemberInfo() {
                let data = {
                    memberId: this.memberId,
                }
                let res = await this.$get("/fw/getFwMember", data)
                if (res.member&&res.member.id){
                    this.member = res.member
                    this.member.phone=this.member.phone.substring(0, 3) + '**** ' + this.member.phone.substring(7);
                }

            },
            setJsType(val){
                this.jsType=val
            },
            fanhui(item){
                if (item){
                    this.$emit('gbPay',item)
                }
                this.$emit('gbPay')
            },
            toShiJian() {
                this.sjShow = true
            },

            queding(val) {
                let date = formatDate(val, 'yyyy-mm-dd')
                this.kdDate = date
                this.quxiao()
            },
            quxiao() {
                this.sjShow = false
            },
            async getPayTypes(){
                let data={
                    deptId:this.deptId
                }
                if (this.cardId){
                    data.cardId=this.cardId
                }
                let res = await this.$get("/sw/getPayTypes", data);
                this.payTypes=res.pays
            },
            async jiesuan() {
                if (this.jsType==2){
                    this.$notify({type: 'danger', message: "混合结算正在调试,后续升级!"});
                    return ;
                }
                this.isDisabled = true
                this.data.payType=this.payType
                if (this.radio==2){
                    var now = new Date();
                    var hours = now.getHours();
                    var minutes = now.getMinutes();
                    var seconds = now.getSeconds();
                    let xfm=hours+':'+minutes+':'+seconds
                    this.data.xdTime=this.kdDate+' '+xfm
                }
                let res = await this.$post("/fw/fwOrderSettlement", this.data);
                if (res.code == 200) {
                  this.fanhui("save")
                } else {
                    this.isDisabled=false
                    this.$notify({type: 'danger', message: res.message});
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .srdate2 {
        display: block;
        width: 100px;
        line-height: 45px;
        text-align: right;
    }

    .jisuanje {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 13px;
        height: 43px;
        line-height: 50px;
        border-bottom: #EEEEEE solid 1px;
    }

    .jisuanfs {
        width: 90%;
        margin: auto;
        font-size: 13px;
        padding-top: 10px;
    }

    .radio-btn {
        height: 36px;
        font-size: 13px;
    }

    .mb-sex {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
    }

    .xmbt {
        display: block;
        text-align: center;
        font-size: 15px;
        padding: 16px 10px;
        background-color: #CCD5E6;
    }

    .jiesuan-btn {
        width: 100%;
        position: fixed;
        bottom: 0px;
    }

    .jiesuan-btn .jiesuanbtn {
        width: 100%;
        text-align: center;
        height: 40px;
        background-color: red;
        color: #ffffff;
    }

    ::v-deep .van-radio__icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -ms-flex: none;
        flex: none;
        height: 1em;
        font-size: 13px;
        line-height: 1em;
        cursor: pointer;
        position: absolute;
        right: 30px;
    }

    .hunhepay{
        width: 90%;
        margin: auto;
        padding-top: 10px;
        font-size: 13px;
    }
    .hhitem{
      padding-bottom: 20px;
    }
    .paykuang-item {
        width: 90%;
        margin: auto;
        display: flex;
        flex-direction: row;
        font-size: 13px;
        border-bottom: #EEEEEE solid 1px;
        height: 35px;
        line-height: 35px;
    }
    .paykuang-item span{
        width: 45px;
    }
    .paykuang-item .ki {
        width: 60%;
    }
    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff !important;
        border-radius: 0px;
    }

    ::v-deep .el-input.is-disabled .el-input__inner {
        background-color: #ffffff;
        cursor: not-allowed;
    }


</style>